import { useEffect, useState } from "react";
import { useAuth0 } from "../../react-auth0-spa";

const ChatWidgetLoader = () => {
  const { fetchWithCheck } = useAuth0();
  const [isReachable, setIsReachable] = useState(false);

  useEffect(() => {
    fetchWithCheck("/client-ip").then((data) => {
      console.log("Client IP:", data);
      if (data && data.isIntranet) {
        setIsReachable(true);
      }
    });
  }, [fetchWithCheck]);

  useEffect(() => {
    if (!isReachable) return;

    const script = document.createElement("script");
    script.src =
      "https://elementllm.elembio.io:3001/embed/anythingllm-chat-widget.min.js";
    script.setAttribute(
      "data-embed-id",
      "538ce855-d2d6-4158-b7c7-157d99c62bdc"
    );
    script.setAttribute(
      "data-base-api-url",
      "https://elementllm.elembio.io:3001/api/embed"
    );
    script.async = true;
    
    // Add CSS fix after widget loads
    script.onload = () => {
      setTimeout(() => {
        const style = document.createElement('style');
        style.id = 'chat-widget-fix';
        style.textContent = `
          /* Fix the main container that's blocking clicks */
          #anything-llm-embed-chat-container.allm-fixed.allm-inset-0 {
            pointer-events: none !important;
            background: transparent !important;
          }
          
          /* Keep the actual chat widget clickable */
          #anything-llm-chat {
            pointer-events: auto !important;
          }
          
          /* Alternative fix for the container */
          .allm-fixed.allm-inset-0.allm-z-50 {
            pointer-events: none !important;
          }
          
          .allm-fixed.allm-inset-0.allm-z-50 > * {
            pointer-events: auto !important;
          }
        `;
        document.head.appendChild(style);
      }, 1000);
    };
    
    document.body.appendChild(script);

    return () => {
      // Remove the script
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      
      // Remove the custom style
      const existingStyle = document.getElementById('chat-widget-fix');
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
      
      // Remove the chat widget container
      const chatContainer = document.getElementById('anything-llm-embed-chat-container');
      if (chatContainer) {
        chatContainer.remove();
      }
      
      // Remove any other chat widget elements that might persist
      const chatElements = document.querySelectorAll('[id*="anything-llm"], [class*="allm-"]');
      chatElements.forEach(element => {
        if (element.parentNode) {
          element.parentNode.removeChild(element);
        }
      });
    };
  }, [isReachable]);

  return null;
};

export default ChatWidgetLoader;